





























import Vue from 'vue';
import {
  faFacebookF,
  faInstagram,
  faTwitter,
  faWhatsapp,
} from '@fortawesome/free-brands-svg-icons';

import {eventBus} from '@/event-bus';


export default Vue.extend({
  name: 'social-icons',
  props: {
    isDesktop: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      eventBus,
      faFacebookF,
      faInstagram,
      faTwitter,
      faWhatsapp,
      desktopStyles: ['d-none', 'd-lg-flex', 'ml-auto'],
      mobileStyles: ['mx-auto', 'd-lg-none'],
      contactNumber: '+27823455998',
      whatsappText: 'I\'m%20interested%20in%20your%20services%20',
      modalShow: false,
    };
  },

  methods: {
    openFacebook (): void {
      this.openWindow('https://www.facebook.com/Timeless-Design-279212152199509');
    },

    openInstagram (): void {
      this.openWindow('https://www.instagram.com/timelessdesignct/');
    },

    whatsappContact (): void {
      this.openWindow(`https://wa.me/${this.contactNumber}?text=${this.whatsappText}`);
    },

    generateMailTo (): void {
      this.openWindow('mailto:mark@timelessdesign.co.za?subject=Mail%20from%20Our%20Site');
    },

    openWindow (url: string) {
      window.open(url, '_blank');
    },

    openSharingModal (): void {
      this.eventBus.$emit('open-social-sharing', true);
    },
  },
});
